import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kHTMLCore } from "../../../Admin/kReusableCoreTS/kHTMLCore";

// AppNotice - the one-line "that worked" at the top of the main screen after a task elsewhere
// finished (owner, 2026-09-25: "A successful save should bring me back to the main screen").
//
// ⚠ RULES ONLY - no DOM, no timers. `AppMain` sets it, paints `Html()` at the top of the list, and
// removes the element after `FadeMs`; the lifecycle is here so it can be tested.
//
// ⚠ IT SURVIVES UNTIL IT HAS BEEN SEEN, AND NOT A ROUTE LONGER. A save that lands on a page with no
// archive open yet goes through "Opening your archive..." before the list paints - a notice cleared
// on the first route change would be gone before anybody could read it. So `OnRoute` clears only a
// notice that `Html` has already painted, and the NEXT navigation after that takes it away.
//
// ⚠ INK, `role="status"`: it is good news, and it does not take focus or block anything.

export class AppNotice {
    public static readonly Id: string = "wac-notice";
    /** The element removes itself after this long - just the element, never a repaint. */
    public static readonly FadeMs: number = 10000;

    private Text: string = "";
    private Shown: boolean = false;

    /** A new notice, to be painted on the next main-screen paint. */
    public Set = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Text = nz(Text).trim();
            this.Shown = false;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppNotice.Set");
        }
    };

    /** The paragraph, or "" - and painting it marks it SHOWN, so the next route clears it. */
    public Html = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (this.Text.length === 0) { return ""; }
            this.Shown = true;
            return "<p class=\"notice\" id=\"" + AppNotice.Id + "\" role=\"status\">"
                + kHTMLCore.EscapeHtml(this.Text) + "</p>";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppNotice.Html");
            return "";
        }
    };

    /** A navigation happened: a notice already seen goes; one not yet painted waits for its paint. */
    public OnRoute = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Shown === true) { this.Clear(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppNotice.OnRoute");
        }
    };

    public Clear = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Text = "";
            this.Shown = false;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppNotice.Clear");
        }
    };

    /** Is there anything to paint? */
    public Has = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return this.Text.length > 0;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppNotice.Has");
            return false;
        }
    };

    /** After a Claude token was saved. ⚠ It says the token was CHECKED, and when it takes effect. */
    public static readonly ClaudeSaved: string = "Your Claude token was checked with Claude and stored."
        + " The next analysis cycle uses it.";
}
